export function attachReviewAutoplay(root, advance) {
  const slides = root.querySelector('.reference-slides');
  const tabs = [...root.querySelectorAll('[role="tab"]')];
  if (!slides || tabs.length < 2) return () => {};
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let visible = false;
  let hovering = false;
  let timer;
  let focused = root.contains(document.activeElement);
  const clear = () => window.clearTimeout(timer);
  const schedule = () => {
    clear();
    if (!visible || hovering || document.hidden || motion.matches || focused) return;
    timer = window.setTimeout(() => { advance(); schedule(); }, 2000);
  };
  const enter = event => { if (event.pointerType === 'mouse') { hovering = true; schedule(); } };
  const leave = () => { hovering = false; schedule(); };
  const focus = event => { focused = event.type === 'focusin' || root.contains(event.relatedTarget); schedule(); };
  const observer = new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting;
    schedule();
  }, { threshold: 0 });
  observer.observe(slides);
  root.addEventListener('pointerenter', enter);
  root.addEventListener('pointerleave', leave);
  root.addEventListener('focusin', focus);
  root.addEventListener('focusout', focus);
  root.addEventListener('click', schedule);
  document.addEventListener('visibilitychange', schedule);
  motion.addEventListener('change', schedule);
  return () => {
    clear(); observer.disconnect();
    root.removeEventListener('pointerenter', enter);
    root.removeEventListener('pointerleave', leave);
    root.removeEventListener('focusin', focus);
    root.removeEventListener('focusout', focus);
    root.removeEventListener('click', schedule);
    document.removeEventListener('visibilitychange', schedule);
    motion.removeEventListener('change', schedule);
  };
}
